import { createModuleStore } from '../utils'

export const useRolesStore = createModuleStore(
  'roles',
  {
    type: 'Role',
    pageHeading: 'Roles',
    noHistory: true,
    noSettings: true,
    sortingOn: 'toolbar',
    statusesFilterName: 'statuses',
    downloadOptionsCsv: '',
    uploadOptionsCsv: '',
    uri: '/roles',
    serviceUri: '/roles',
    listingModuleName: 'AccessControl',
    listingActivityName: 'View Role',
    formModuleName: 'AccessControl',
    formActivityName: 'Edit Role',
    allFields: [
      {
        key: 'name',
        title: 'NAME',
        visible: true,
        sortable: true,
        disabled: true,
      },
      {
        key: 'identifier',
        title: 'IDENTIFIER',
        visible: true,
        sortable: false,
        disabled: true,
      },
      {
        key: 'mappedRolesJson',
        title: 'MAPPED AD ROLE(S)',
        type: 'mappedRolesJson',
        visible: false,
        sortable: false,
        disabled: false,
      },
      { key: 'landingPageUri', title: 'LANDING PAGE URI', visible: false, sortable: true, disabled: false },
      {
        key: 'createdBy',
        title: 'CREATED BY',
        visible: true,
        sortable: true,
        disabled: false,
      },
      {
        key: 'createdTimestamp',
        title: 'CREATED TIME',
        type: 'datetime',
        visible: true,
        sortable: true,
        disabled: false,
      },
      {
        key: 'lastModifiedBy',
        title: 'LAST MODIFIED BY',
        visible: true,
        sortable: true,
        disabled: false,
      },
      {
        key: 'lastModifiedTimestamp',
        title: 'LAST MODIFIED TIME',
        type: 'datetime',
        visible: true,
        sortable: true,
        disabled: false,
      },
      {
        key: 'actions',
        title: 'ACTIONS',
        visible: true,
        disabled: true,
        sortable: false,
      },
    ],
  },
  {},
  {
    copy(item) {
      const obj = {
        mappedRoles: item.mappedRolesJson?.length > 0 ? JSON.parse(item.mappedRolesJson) : [],
        landingPageUri: item.landingPageUri,
      }
      obj.mappedRolesOptions = obj.mappedRoles.map((role) => ({ label: role, value: role }))
      return obj
    },
    transform(item) {
      const obj = {
        externalId: item.externalId,
        landingPageUri: item.landingPageUri,
        identifier: item.identifier,
        name: item.name,
        mappedRoles: item.mappedRolesJson?.length > 0 ? JSON.parse(item.mappedRolesJson) : [],
      }
      obj.mappedRolesOptions = obj.mappedRoles.map((role) => ({ label: role, value: role }))
      return obj
    },
    nameUpdated(n) {
      const store = useRolesStore()
      const name = n ?? ''
      store.formData.identifier = `ROLE_${name.toUpperCase()}`
    },
  },
  {
    actionBindings: { name: 'nameUpdated' },
    fields: [
      {
        id: 'role_name',
        name: 'name',
        label: 'Name',
        size: 12,
        componentProps: { placeholder: 'Enter name of the role' },
        component: 'NInput',
        rules: [
          {
            required: true,
            trigger: ['blur', 'input'],
          },
          {
            trigger: 'blur',
            remoteValidator: 'isNameUnique',
          },
        ],
      },
      {
        id: 'role_mapped_roles',
        name: 'mappedRoles',
        label: 'Mapped Roles',
        size: 12,
        component: 'ArsTagSelect',
        defaultValue: [],
        componentProps: {
          multiple: true,
          filterable: true,
          placeholder: 'Select mapped roles',
          optionsKey: 'mappedRolesOptions',
        },
        rules: [
          {
            required: false,
            type: 'array',
            trigger: ['blur', 'input'],
          },
        ],
      },
      {
        id: 'role_identifier',
        name: 'identifier',
        label: 'Identifier',
        size: 12,
        component: 'NInput',
        componentProps: { placeholder: 'Enter identifier of the role' },
        rules: [
          {
            required: true,
            trigger: ['blur', 'input'],
          },
          {
            trigger: 'blur',
            remoteValidator: 'isRoleIdentifierUnique',
          },
        ],
      },
      {
        id: 'role_landing_page_uri',
        name: 'landingPageUri',
        label: 'Landing Page URI',
        size: 12,
        component: 'NInput',
        defaultValue: '',
        componentProps: { placeholder: 'Enter landing page URI' },
        rules: [
          {
            required: false,
            trigger: ['blur', 'input'],
          },
        ],
      },
    ],
  }
)
